import React from "react";
import { LaneTitle } from "react-trello/dist/styles/Base";
import { CheckBox } from "../../Form";
import { InfoTooltip } from "../../Tooltip";
import "./styles.scss";

export const LaneBoard = (props) => {
  const {
    title,
    id,
    handleSelectedAllCardsOnBoard,
    isCheckAll,
    cards,
    selectedCardOnBoard,
    bucketDescription
  } = props

  return (
    <div className="lane-kanban" key={id}>
      <CheckBox
        onChange={(e) => handleSelectedAllCardsOnBoard(e, cards)}
        value={id}
        checked={isCheckAll[id] || (selectedCardOnBoard?.length > 0 && cards?.length > 0 && cards.every(card => selectedCardOnBoard.some(selected => selected.id === card.id)))}
      />
      <LaneTitle className="bucketTitle">
        {`${title} (${cards?.length})`}
        <InfoTooltip info={bucketDescription} trigger="click"></InfoTooltip>
      </LaneTitle>
    </div>
  )
}
